import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import DesignWizardViewModel from '@/ViewModels/Controls/DesignWizardViewModel';
import DesignWizard from '@/Controls/DesignWizard';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';

export default class DesignWizardFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private DesignWizardViewModel = ComponentManager.getViewModel<typeof DesignWizardViewModel>('DesignWizardViewModel');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');

    /**
     * @override
     */
    public viewModel: DesignWizardViewModel;

    public constructor(params: any) {
        super(params);
        this.labelPosition = 'None';
    }

    /**
     * @override
     */
    control: DesignWizard;

    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }
        
        this.viewModel = new this.DesignWizardViewModel({
            parentLocator: this.locator,
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            locator: this.detailViewItem.name,
            factory: this,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            invalidationText: this.invalidationText,
            definition: this.context.genericObject.getObservable(this.detailViewItem.name),
            context: this.context
        });

        this.control = new DesignWizard(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        return this.jQueryControl;
    }
}

ComponentManager.setFactory('DesignWizard', DesignWizardFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setFactory('RADPresentation.DefaultViewExtensions.UIComponents.DesignWizardHTML', DesignWizardFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');